import * as React from 'react';
import { FieldDisplayName } from '../types/FieldCopy';
import ToolTip from '@payscale/design/lib/tooltip';
import './style/index.scss';
export class ErrorRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleInviteUser = this.handleInviteUser.bind(this);
        this.handleIgnoreUser = this.handleIgnoreUser.bind(this);
        this.state = { isOpen: false };
    }
    render() {
        const employee = this.props.employee;
        if (!employee) {
            return null;
        }
        return this.renderEmployeeObject(employee);
    }
    renderEmployeeObject(employee) {
        const iconClassName = this.state.isOpen ? 'icon-up-open' : 'icon-down-open';
        const errorStateclassName = this.state.isOpen ? 'error-row--open' : '';
        this._errorCount = this.countEmployeeErrors();
        const editClassModifier = this._errorCount === 1 && employee.errorDetails.missingUser
            ? 'error-row__edit--hidden'
            : '';
        if (this._errorCount === 0) {
            return null;
        }
        return (React.createElement("li", { className: `error-row ${errorStateclassName}`, onClick: this.handleRowClick },
            React.createElement("div", { className: "error-row__top-container" },
                this.renderEmployeeInformation(employee),
                React.createElement("div", { className: "error-row__error" },
                    React.createElement("div", { className: "error-count" }, this._errorCount),
                    React.createElement("a", { className: `error-row__edit ${editClassModifier}`, onClick: this.handleEditClick }, "Edit"),
                    React.createElement("i", { className: `${iconClassName} arrow-icon` }))),
            this.renderDataTable()));
    }
    renderEmployeeInformation(employee) {
        const { labEmployee } = employee;
        const { errorDetails } = employee;
        const nameError = errorDetails.firstName || errorDetails.lastName;
        const jobTitleError = errorDetails.orgJobTitle;
        const fullNameError = errorDetails.firstName && errorDetails.lastName;
        const nameText = fullNameError
            ? 'Unknown Employee Name'
            : `${labEmployee.firstName} ${labEmployee.lastName}`;
        const employeeNameWarningText = fullNameError
            ? `Invalid ${FieldDisplayName.FirstName} and ${FieldDisplayName.LastName}`
            : `Invalid ${this.fieldNameWithError(employee)}`;
        const jobText = jobTitleError ? 'Unknown Job Title' : labEmployee.orgJobTitle;
        return (React.createElement("div", { className: "error-row__information" },
            React.createElement("div", { className: "employee-name" }, nameText),
            nameError &&
                React.createElement("div", { className: "employee-name-error" }, this.renderWarning(employeeNameWarningText)),
            React.createElement("div", { className: "employee-job-title" }, jobText),
            jobTitleError &&
                React.createElement("div", { className: "employee-job-title-error" }, this.renderWarning('Invalid Job Title'))));
    }
    renderDataTable() {
        return (React.createElement("div", { className: "data-table" },
            this.renderDataTableColumns(),
            this.renderMissingUserAlert()));
    }
    renderDataTableColumns() {
        const { teamEmployee } = this.props.employee;
        const { labEmployee } = this.props.employee;
        const { errorDetails } = this.props.employee;
        return (React.createElement("div", { className: "data-table__column-container" },
            React.createElement("div", { className: "data-table__left-column" },
                this.renderDataItem('Employee ID', labEmployee.employeeNumber, errorDetails.employeeNumber),
                this.renderDataItem('Hire Date', labEmployee.dateOfHire ? labEmployee.dateOfHire.toDateString() : '', errorDetails.dateOfHire),
                this.renderDataItem('Manager ID', labEmployee.managerNumber, errorDetails.managerNumber),
                this.renderDataItem('Email Address', teamEmployee.workEmail, errorDetails.workEmail, errorDetails.duplicateEmail)),
            React.createElement("div", { className: "data-table__right-column" },
                this.renderDataItem('Pay Type', labEmployee.annualOrHourly, errorDetails.annualOrHourly),
                this.renderDataItem('Standard Work Hours', labEmployee.standardWorkHours, errorDetails.standardWorkHours),
                this.renderDataItem('Currency Code', labEmployee.currency, errorDetails.currency),
                this.renderDataItem('Country Code', teamEmployee.countryCode, errorDetails.countryCode))));
    }
    renderMissingUserAlert() {
        const { errorDetails, teamEmployee, labEmployee } = this.props.employee;
        if (!errorDetails.missingUser) {
            return null;
        }
        const hoverText = 'There is no user associated with this manager.' +
            ' This manager will not be able to login to team';
        return (React.createElement("div", { className: "missing-user-alert" },
            React.createElement("div", { className: "missing-user-alert__content" },
                React.createElement("div", { className: "missing-user-alert__alert-text" },
                    "Manager user does not exist in Team",
                    React.createElement(ToolTip, { id: labEmployee.employeeNumber, hoverText: hoverText, tooltipText: "", className: "missing-user-alert__icon" })),
                React.createElement("div", { className: "missing-user-alert__ignore-add-user-container" },
                    React.createElement("a", { className: "missing-user-alert__ignore-user-link", onClick: this.handleIgnoreUser }, "Ignore User"),
                    React.createElement("button", { onClick: this.handleInviteUser, className: "missing-user-alert__add-user-button pxl-btn", disabled: !teamEmployee.workEmail }, "Add User")))));
    }
    renderDataItem(header, data, error, additionalError) {
        const errorText = error ? `${error} ${header}` : '';
        const additionalErrorText = additionalError ? `${additionalError} ${header}` : '';
        const displayText = (data !== null && data !== void 0 ? data : 'XXX XXX');
        const noDataClassName = !!data ? '' : 'data-table__item-content--no-data';
        return (React.createElement("div", { className: "data-table__item" },
            React.createElement("div", { className: "data-table__item-header" }, header),
            React.createElement("div", { className: `data-table__item-content ${noDataClassName}` }, displayText),
            error &&
                React.createElement("div", { className: "data-table__item-error" }, this.renderWarning(errorText)),
            additionalError &&
                React.createElement("div", { className: "data-table__additional-item-error" }, this.renderWarning(additionalErrorText))));
    }
    renderWarning(warningText) {
        return (React.createElement("div", { className: "warning-pill" },
            React.createElement("div", { className: "icon-reverse icon-circle " },
                React.createElement("i", { className: "icon-attention-alt" })),
            warningText));
    }
    fieldNameWithError(employee) {
        return employee.errorDetails.firstName ? FieldDisplayName.FirstName : FieldDisplayName.LastName;
    }
    handleRowClick() {
        this.setState({ isOpen: !this.state.isOpen });
    }
    handleEditClick(event) {
        this.props.onEditClickCallBack();
    }
    countEmployeeErrors() {
        return this.props.employee.errorDetails ? Object.keys(this.props.employee.errorDetails).length : 0;
    }
    handleIgnoreUser() {
        const { ignoreUserCallBack, employee } = this.props;
        if (ignoreUserCallBack) {
            const { labEmployee } = employee;
            const userRequest = {
                userEmail: labEmployee.email,
                firstName: labEmployee.firstName,
                lastName: labEmployee.lastName,
                employeeId: labEmployee.employeeNumber
            };
            ignoreUserCallBack(userRequest);
        }
    }
    handleInviteUser() {
        const { inviteUserCallBack, employee } = this.props;
        const labEmployee = employee.labEmployee;
        const teamEmployee = employee.teamEmployee;
        if (inviteUserCallBack) {
            const userRequest = {
                userEmail: teamEmployee.workEmail,
                firstName: labEmployee.firstName,
                lastName: labEmployee.lastName,
                employeeId: labEmployee.employeeNumber
            };
            inviteUserCallBack(userRequest);
        }
    }
}
